export default {
  name: 'icon-close-svg'
};